module.exports = __webpack_public_path__ + "img/img14_1.3ef691b2.svg";